import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { WorkoutCardSkeleton } from 'src/component/ui/workout-card/workout-card-skeleton'

export const FlexFlowWorkoutHomeCardListSkeleton = (): React.ReactElement => {
  return (
    <Container fluid className="px-0">
      <Row>
        <Col xs={12} lg={3} className="mb-7 lg:mb-0">
          <WorkoutCardSkeleton />
        </Col>
        <Col xs={12} lg={3} className="mb-7 lg:mb-0">
          <WorkoutCardSkeleton />
        </Col>
        <Col xs={12} lg={6}>
          <WorkoutCardSkeleton />
        </Col>
      </Row>
    </Container>
  )
}
